
import Vue from "vue";
import ColumnsSelectionButton from "@/components/ColumnsSelectionButton.vue";
import Sortable from "sortablejs";

export default Vue.extend({
  name: "MemoryDataTable",
  components: {
    ColumnsSelectionButton,
  },
  props: {
    columns: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] },
    dense: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    multiSelect: { type: Boolean, default: false },
    singleSelect: { type: Boolean, default: false },
    itemKey: { type: String },
    showPagination: {
      type: Boolean,
      default: false,
    },
    externalPagination: {
      type: Boolean,
      default: false,
    },
    showColumnSelection: {
      type: Boolean,
      default: false,
    },
    itensPorPagina: {
      type: Number,
      default: 10,
    },
    totalItensServer: {
      type: Number,
      default: null,
    },
    objetoPaginacao: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      default: false,
    },
    height: {
      type: String,
    },
    defaultColumnsFilter: {
      type: Array,
      default: () => [],
    },
    draggable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    filtroColunas: [] as string[],
  }),

  computed: {
    paginacao: {
      get: function (): any {
        return this.$props.objetoPaginacao || undefined;
      },
      set: function (value: any) {
        this.$emit("update:objetoPaginacao", value);
      },
    },
    itensPagina: {
      get: function (): any {
        return this.$props.itensPorPagina || undefined;
      },
      set: function (value: any) {
        this.$emit("update:itensPorPagina", value);
      },
    },

    totalItens(): any {
      if (!this.$props.externalPagination) {
        return undefined;
      }
      return this.$props.totalItensServer || this.$props.items.length;
    },

    selected: {
      get: function (): any {
        return this.$props.value;
      },

      set: function (value: any) {
        this.$emit("input", value);
      },
    },

    visibleColumns(): string[] {
      const visibleColumns = this.$props.columns.filter(
        (el) =>
          !this.filtroColunas.includes(el.value) &&
          !this.$props.defaultColumnsFilter.includes(el.value)
      );

      // if is mobile, don't show draggable column
      if (this.$vuetify.breakpoint.smAndDown) {
        return visibleColumns;
      }

      // draggable column
      if (this.$props.draggable) {
        visibleColumns.unshift({
          text: "",
          value: "draggable",
          sortable: false,
          width: "10px",
        });
      }

      return visibleColumns;
    },
  },
  methods: {
    ordenation(event: any) {
      const movedItem = this.items.splice(event.oldIndex, 1)[0];
      this.items.splice(event.newIndex, 0, movedItem);
      this.$emit("itemsPositionChanged", this.items);
    },
  },
  directives: {
    sortableDataTable: {
      bind(el, binding, vnode) {
        if (!binding.arg) return;
        el.style.cursor = "move";

        const options = {
          delayOnTouchOnly: true,
          animation: 150,
          disabled: !binding.arg,
          onMove: () => {
            if (vnode.context?.$props.loading) return false;
            return true;
          },
          onUpdate: function (event) {
            // emite o evento 'ordenation' para o componente
            vnode.context?.$children[0].$emit("ordenation", event);
          }
        };
        Sortable.create(el.getElementsByTagName("tbody")[0], options);
      },
    },
  },
});
